<template>
  <card
    :title="title"
    :linkTo="linkTo"
    :actionButton="actionButton"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format, addDays } from "date-fns";
import { getApi } from "@/api";
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {
    title() {
      switch (this.from) {
        case "LAMETAYEL":
          return "למטייל";
        case "OFFICE":
          return "משרד";
        case "AIRPORT":
          return "נתב״ג";
        default:
          return "";
      }
    },
    actionButton() {
      switch (this.from) {
        case "LAMETAYEL":
          return "כל האיסופים מלמטייל היום";
        case "OFFICE":
          return "כל האיסופים מהמשרד היום";
        case "AIRPORT":
          return "כל האיסופים מנתב״ג היום";
        default:
          return "";
      }
    },
    receiveType() {
      let receiveType = Object.values(
        this.$store.state.entities.receiveTypes
      ).find(item => {
        return item.key === this.from;
      });
      if (receiveType) {
        return receiveType._id;
      } else {
        return "";
      }
    },
    paidOrderStatus() {
      let orderStatus = Object.values(
        this.$store.state.entities.orderStatuses
      ).find(item => {
        return item.key === 'PAID';
      });
      if (orderStatus) {
        return orderStatus._id;
      } else {
        return "";
      }
    },
    linkTo() {
      return `/orders?receiveTypes=${this.receiveType}&startDateBefore=${format(
        addDays(Date(), 1),
        "YYYY-MM-DD"
      )}&startDateAfter=${format(Date(), "YYYY-MM-DD")}`;
    }
  },

  methods: {
    format,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            startDateBefore: format(addDays(Date(), 1), "YYYY-MM-DD"),
            startDateAfter: format(Date(), "YYYY-MM-DD"),
            receiveTypes: this.receiveType,
            orderStatuses: this.paidOrderStatus
          };
          return api.get("/orders", { params });
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  props: ["from"],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
